"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.adCarouselFactory = adCarouselFactory;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _adPlacementFactory = require("./ad-placement.factory.js");
var _adSolutionUtils = require("../utils/ad-solution.utils.js");
function adCarouselFactory(adPlacement, zoneId, baseURL, language) {
  var _adPlacement$template;
  var adPlacementPayload = (0, _adPlacementFactory.adPlacementFactory)(adPlacement, zoneId, baseURL);
  return (0, _extends2["default"])({}, adPlacementPayload, {
    title: adPlacement.template_params["title_" + language],
    sub_title: adPlacement.template_params["sub_title_" + language],
    product_ids: (0, _adSolutionUtils.getCarouselIds)(adPlacement === null || adPlacement === void 0 ? void 0 : (_adPlacement$template = adPlacement.template_params) === null || _adPlacement$template === void 0 ? void 0 : _adPlacement$template.product_ids)
  });
}